module.exports = __webpack_public_path__ + "img/pink-words-discover.2809af9d.png";